'use client';

import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';
import { useTheme } from '@unity/cloud-ui/styles';

const phosphorWeights = ['thin', 'light', 'regular', 'bold', 'fill', 'duotone'] as const;

const getPhosphorIcon = (iconName) => {
  const availableIcons = Object.keys(PhosphorIcons);
  if (!iconName || !availableIcons.includes(iconName)) {
    return null;
  }

  return PhosphorIcons[iconName];
};

const getPhosphorWeight = (weight) => {
  const isValidWeight = phosphorWeights.includes(weight);
  return isValidWeight ? weight : 'regular';
};

export interface IconProps {
  name: string;
  color?: string;
  weight?: (typeof phosphorWeights)[number];
  size?: number;
}

export const Icon = (props: IconProps) => {
  const { name, color, weight = 'regular', size = 16 } = props;
  const { palette } = useTheme();

  const PhosphorIcon = getPhosphorIcon(name);
  const phosphorWeight = getPhosphorWeight(weight);
  const phosphorColor = color && color in palette.icons ? palette.icons[color] : palette.primary.main;

  if (!PhosphorIcon) {
    return null;
  }

  return <PhosphorIcon color={phosphorColor} alt={name} size={size} weight={phosphorWeight} />;
};
